<template>
  <div :class="{ exibeLabel: 'form-group' }">
    <label v-if="exibeLabel"> {{ label }} </label>
    <BuscarSelecionar
      :id="id"
      :lista="procedimentos"
      :selecionado="selecionado"
      :minimo="minimo"
      :exibir-chave="false"
      :exibir="['codigoNome']"
      :classes-input="classesInput"
      @selecionar="selecionarProcedimento"
      @limpar="limparProcedimento"
      @recuperar="recuperarProcedimentos"
    />
  </div>
</template>

<script>
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import ConvenioServico from '@/servicos/ConvenioServico'

const convenioServico = new ConvenioServico()

export default {
  name: 'BuscarSelecionarProcedimento',
  components: { BuscarSelecionar },
  props: {
    label: {
      type: String,
      default: 'Procedimento',
    },
    exibeLabel: {
      type: Boolean,
      default: true,
    },
    classesInput: {
      type: String,
      default: 'form-control',
    },
    id: {
      type: String,
      default: 'procedimento',
    },
    minimo: {
      type: Number,
      default: 0,
    },
    convenio: {
      type: Object,
      required: true,
    },
    tabela: {
      type: String,
      required: true,
    },
    selecionado: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      procedimentos: [],
    }
  },
  methods: {
    selecionarProcedimento(procedimento) {
      this.$emit('selecionadoProcedimento', procedimento)
    },
    limparProcedimento() {
      this.$emit('limparProcedimento')
    },
    recuperarProcedimentos(filtro) {
      const codigo = new RegExp('^[0-9]+$').test(filtro.palavra)
        ? filtro.palavra
        : ''
      const nome = new RegExp('^[a-z]+$', 'i').test(filtro.palavra)
        ? filtro.palavra
        : ''
      const tabela = this.convenio.tabelas.find((t) => t.nome === this.tabela)
      const data = {
        nome: nome,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
        codigo: codigo,
        convenio: this.convenio._id,
        idTabela: tabela._id,
      }
      convenioServico.recuperarProcedimentos(data).then((res) => {
        this.procedimentos = []
        res.procedimentos.forEach((procedimento) => {
          const p = procedimento.procedimentos
          p.codigoNome = `${p.codigo} - ${p.nome}`
          this.procedimentos.push(procedimento.procedimentos)
        })
      })
    },
  },
}
</script>
